
import { Link } from 'react-router-dom'
import './member-list-header.css'
import context from "../../scripts/context"
import Input from "../../blocks/Input"
import { useRef, useState } from "react"
import UserModal from '../Modals/User-modal'


const MemberListHeader = ({onFilter , count}) => {
    const userModal = useRef()
    const openModal = () => userModal.current.openModal()
    const [inputs, setInputs] = useState(context.getUserInputFilter())

    const onUserInputFilter = (ins) => {
        setInputs({
            ...ins
         })
    }

    context.addListenerUserInputFilter((ins)=>{onUserInputFilter(ins)})

    const handleSearchChange = (value, name)=>{
        console.log(name,  value)
        const ni = {
            ...inputs,
            [name]: {
                ...inputs.username,
                value: value
            },
        }
        setInputs(ni)
        context.setUserInputFilter(ni)
    }

    const checkEnter = (event) => {
        if (event.keyCode === 13) {
            onFilter(inputs)
        }
    };

    return(
        <div className="user-searchbar">
            <div className="searchbar__input">
                <Input inputField={inputs.username} onChange={handleSearchChange} onKeyDown={e => checkEnter(e)} />
            </div>
            <div className="searchbar__filter">
                <button onClick={openModal}>Filter {(count!== 0 ? <span>{count}</span> : '')}</button>
            </div>
            <div className="searchbar__btn">
                <Link to={"/agent/users/single?type=create"}>
                    <button> + Add New User</button>
                </Link>
            </div>
            <UserModal ref={userModal} onFilter={(inputs) => {setInputs(inputs); onFilter(inputs);}} />
        </div>
    )
}

export default MemberListHeader